var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 32,
    viewBox: "0 0 122 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6492 2.33594H3.88524H0V6.22118V13.9922V17.8774V26.4258V30.3097V30.311H19.4262V26.4258H3.88524V17.8774H17.8721V13.9922H3.88524V6.22118H18.6492V2.33594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7368 0H38.8516V14.2992C37.143 12.2018 34.643 10.8789 31.8578 10.8789C26.708 10.8789 22.5332 15.4016 22.5332 20.9805C22.5332 26.5595 26.708 31.0822 31.8578 31.0822C34.643 31.0822 37.143 29.7593 38.8516 27.6619V30.3049H42.7368V0ZM38.0737 20.982C38.0737 24.4152 35.4645 27.1984 32.2458 27.1984C29.0272 27.1984 26.418 24.4152 26.418 20.982C26.418 17.5488 29.0272 14.7656 32.2458 14.7656C35.4645 14.7656 38.0737 17.5488 38.0737 20.982Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9278 31.0861C82.5068 31.0861 87.0294 26.5634 87.0294 20.9844C87.0294 15.4055 82.5068 10.8828 76.9278 10.8828C71.3488 10.8828 66.8262 15.4055 66.8262 20.9844C66.8262 26.5634 71.3488 31.0861 76.9278 31.0861ZM76.9273 27.2023C80.3605 27.2023 83.1437 24.4191 83.1437 20.9859C83.1437 17.5527 80.3605 14.7695 76.9273 14.7695C73.4941 14.7695 70.7109 17.5527 70.7109 20.9859C70.7109 24.4191 73.4941 27.2023 76.9273 27.2023Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5783 18.1452C95.8073 17.7962 96.0652 17.4437 96.3545 17.0965C97.9086 15.2316 101.146 15.0244 102.571 15.1539V11.2679C101.097 11.0574 98.0157 11.343 95.5783 13.6263V11.6562H90.916V31.0825H95.5783V18.1452Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.891 18.6528C114.358 18.5233 104.922 18.6528 105.292 25.2587C105.727 33.029 116.171 31.8636 118.891 27.9784L118.891 31.0851H121.999V17.0982C121.999 13.6015 115.005 7.38514 106.846 13.6015L108.789 16.3227C111.768 14.5088 117.959 12.4355 118.891 18.6528ZM109.175 26.43C111.114 29.9237 118.11 26.4317 118.111 23.7103C118.111 23.422 118.11 23.1768 118.11 22.9063C118.11 22.5937 118.11 22.2473 118.11 21.7613C110.728 21.3723 107.236 22.9363 109.175 26.43Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0361 11.9578C46.0909 11.2433 44.5226 11.8928 44.3386 13.08C44.1439 13.8487 44.6148 14.5451 44.951 15.191C46.0483 17.0891 47.0927 19.0161 48.2077 20.9034C50.6558 19.6207 52.8381 18.4173 55.0504 16.8981C52.385 15.3032 49.6981 13.5564 47.0361 11.9578Z",
    fill: "#F8931D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0543 16.8828L61.9418 20.9308C60.2608 23.8488 58.4943 27.0469 56.8167 29.9649C56.4325 30.7121 55.5921 31.2575 54.7515 31.0342C53.9686 30.8986 53.4801 30.1811 53.1029 29.5403C51.4723 26.6588 49.8451 23.7771 48.2109 20.9029L55.0543 16.8828Z",
    fill: "#EF3E36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9859 11.9622C63.9451 11.2372 65.5362 11.8963 65.7229 13.1009C65.9205 13.8808 65.4428 14.5874 65.1015 15.2429L61.9402 20.9335L55.0527 16.8855C57.7575 15.2671 60.2849 13.5842 62.9859 11.9622Z",
    fill: "#A01F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdLogo);
export default __webpack_public_path__ + "static/media/edLogo.f220a84e59ecc84f6db963a4394c0e31.svg";
export { ForwardRef as ReactComponent };